import React, { useEffect, useState, useContext, useCallback } from "react";

import {
  Button,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import TablePagination from "@material-ui/core/TablePagination";
import { MainContext } from "../../context/MainContext";
import PageTitle from "../../components/PageTitle/PageTitle";
import Api from "../../constant/Api";
import { useHistory } from "react-router-dom";
import { getRequest } from "../../constant/ApiService";
import { useParams } from "react-router-dom";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import useStyles from "../../components/styles/styles";
import Input from "../../components/utils/Input";
import { Pagination } from "@material-ui/lab";
const DriversList = () => {
  const [items, setItems] = useState([]);
  const history = useHistory();
  const { id } = useParams();
  const classes = useStyles();

  const [driverSearch, setDriverSearch] = useState({
    userId: "",
    status: "",
    smartCardNumber: "",
    nationalId: "",
    phone: "",
  });
  // let { handleChangeRowsPerPage, rowsPerPage, page, setPage } = useContext(
  //   MainContext,
  // );
  const [page, setPage] = useState(1);
  const [count, setCount] = useState([]);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const getDriverList = () => {
    console.log(driverSearch)
    getRequest(
      `${Api.GetDriversInfoList}?Phone=${driverSearch.phone}&NationalId=${
        driverSearch.nationalId
      }&SmartCardNumber=${driverSearch.smartCardNumber}&Status=${
        driverSearch.status
      }&UserId=${driverSearch.userId}&PageNumber=${page}&PageSize=20`,
    ).then(res => {
      setItems(res && res.data);
      setCount(res && res.data.count)

    });
  };
  useEffect(() => {
    getDriverList();
  }, []);


  const handleChange = (event, value) => {
    setPage(value);
    getDriverList();
  };

  return (
    <Grid>
      <PageTitle title="لیست  رانندگان" />
      <Grid container>
        <Grid
          className={classes.colItem}
          item
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          <label>شماره تلفن </label>
          <Input
            name="phone"
            onChange={({ target }) =>
              setDriverSearch({
                ...driverSearch,
                phone: target.value,
              })
            }
            value={driverSearch.phone}
            type="number"
          />
        </Grid>
        <Grid
          className={classes.colItem}
          item
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          <label>شناسه ملی </label>
          <Input
            name="natinalId"
            onChange={({ target }) =>
              setDriverSearch({ ...driverSearch, nationalId: target.value })
            }
            value={driverSearch.nationalId}
            type="number"
          />
        </Grid>
        <Grid
          className={classes.colItem}
          item
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          <label>شماره کارت </label>
          <Input
            name="smartCardNumber"
            onChange={({ target }) =>
              setDriverSearch({
                ...driverSearch,
                smartCardNumber: target.value,
              })
            }
            value={driverSearch.smartCardNumber}
            type="number"
          />
        </Grid>

        
        <Grid
          container
          justifyContent="space-between"
          direction="row-reverse"
          style={{ padding: "20px 0" }}
        >
          <Grid style={{ display: "flex" }}>
            <Button
              variant="contained"
              style={{ color: "#fff", backgroundColor: "#3CD4A0" }}
              onClick={getDriverList}
            >
              جستجو کنید
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <TableContainer component={Paper}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell>ردیف</TableCell>
              <TableCell> نام</TableCell>
              <TableCell>نام خانوادگی</TableCell>
              <TableCell>کد ملی</TableCell>
              <TableCell>شماره گواهینامه </TableCell>
              <TableCell>شماره کارت هوشمند</TableCell>
              <TableCell>نام شهر</TableCell>
              <TableCell>مدرک تحصیلی</TableCell>
              <TableCell>شماره تلفن</TableCell>
              <TableCell>برند کامیون</TableCell>
              <TableCell>اقدام</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items &&
              items.lists &&
              items.lists.map((item, index) => (
                <TableRow key={index}>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailDriver`,
                        state: item,
                      });
                    }}
                  >
                    {index + 1}
                  </TableCell>
                  {/* <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailDriver`,
                        state: item,
                      });
                    }}
                  >
                    {item.id}
                  </TableCell> */}
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailDriver`,
                        state: item,
                      });
                    }}
                  >
                    {item.firstName}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailDriver`,
                        state: item,
                      });
                    }}
                  >
                    {item.lastName}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailDriver`,
                        state: item,
                      });
                    }}
                  >
                    {item.num_Card_National}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailDriver`,
                        state: item,
                      });
                    }}
                  >
                    {item.num_Certificate}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailDriver`,
                        state: item,
                      });
                    }}
                  >
                    {item.num_Smart_Card}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailDriver`,
                        state: item,
                      });
                    }}
                  >
                    {item.birthDayCityName}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailDriver`,
                        state: item,
                      });
                    }}
                  >
                    {item.degreeName}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailDriver`,
                        state: item,
                      });
                    }}
                  >
                    {item.phone}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailDriver`,
                        state: item,
                      });
                    }}
                  >
                    {item.brandName}
                  </TableCell>
                  <TableCell>
                    <IconButton
                      aria-label="more"
                      aria-controls="long-menu"
                      aria-haspopup="true"
                      onClick={handleClick}
                    >
                      <MoreVertIcon />
                    </IconButton>
                    <Menu
                      id="long-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={open}
                      onClose={handleClose}
                      PaperProps={{
                        style: {
                          width: "20ch",
                        },
                      }}
                    >
                      <MenuItem selected="Pyxis" onClick={handleClose}>
                        <Button
                          style={{ width: "100%" }}
                          variant="contained"
                          color="primary"
                        >
                          مدیریت مالی
                        </Button>
                      </MenuItem>

                      <MenuItem selected="Pyxis" onClick={handleClose}>
                        <Button
                          style={{ width: "100%" }}
                          variant="contained"
                          color="secondary"
                        >
                          قراردادی
                        </Button>
                      </MenuItem>
                    </Menu>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
  
      <Pagination
                  count={items.lists && items.lists.length > 0 ? Math.ceil(count / 20) : 0}
                  page={page}
                  onChange={handleChange}
                  color="primary"
                  variant="outlined"
                  shape="rounded"
                  size="large"
                  style={{ marginTop: "2vh" }}
             />
    </Grid>
  );
};
export default DriversList;
